require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-project-kickoff-small-products.json") })
        }
      }, "path---workshops-project-kickoff-small-products");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-project-kickoff-small-products!./.cache/json/workshops-project-kickoff-small-products.json
// module id = 509
// module chunks = 231608221292675